(() => {
  if (customElements.get("feature-tabs")) return;

  class FeatureTabs extends HTMLElement {
    constructor() {
      super();

      this.onClick = this.onClick.bind(this);
      this.onAnimationEnd = this.onAnimationEnd.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      this.items = [...this.querySelectorAll("[data-feature-item]")];
      this.images = [...this.querySelectorAll("[data-feature-image]")];

      this.addEventListener("click", this.onClick);

      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!this.hasAttribute("data-autoplay") || reducedMotion || this.items.length < 2) return;

      this.addEventListener("animationend", this.onAnimationEnd);
      this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0.25 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("animationend", this.onAnimationEnd);
      this.observer?.disconnect();
    }

    onClick(event) {
      const item = event.target.closest("[data-feature-trigger]")?.closest("[data-feature-item]");
      if (item) this.setActive(this.items.indexOf(item));
    }

    onAnimationEnd(event) {
      if (!event.target.matches("[data-feature-progress]")) return;

      const activeIndex = this.items.findIndex((item) => item.classList.contains("is-active"));
      this.setActive((activeIndex + 1) % this.items.length);
    }

    onIntersect([entry]) {
      this.classList.toggle("is-playing", entry.isIntersecting);
    }

    setActive(activeIndex) {
      this.items.forEach((item, index) => {
        const isActive = index === activeIndex;
        item.classList.toggle("is-active", isActive);
        item.querySelector("[data-feature-trigger]")?.setAttribute("aria-expanded", String(isActive));
      });
      this.images.forEach((image, index) => image.classList.toggle("is-active", index === activeIndex));
    }
  }

  customElements.define("feature-tabs", FeatureTabs);
})();
